import React from "react";
import { AlertTriangle } from "lucide-react";
import { problem, media } from "../../content/siteContent";
import { SectionHeading } from "./primitives";
import { Reveal } from "../motion/Reveal";

export const OperatingProblem = () => (
  <section data-testid="problem-section" className="bg-offwhite py-24 lg:py-32 relative overflow-hidden">
    <div className="absolute inset-0 blueprint-light opacity-70" />
    <div className="container-page relative grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-7">
        <SectionHeading eyebrow={problem.eyebrow}>{problem.heading}</SectionHeading>
        <Reveal delay={0.1}>
          <p className="mt-6 text-slate-ink text-base lg:text-lg leading-relaxed max-w-2xl">
            {problem.intro}
          </p>
        </Reveal>
        <div className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-4">
          {problem.symptoms.map((sym, i) => (
            <Reveal key={sym} delay={i * 0.06}>
              <div className="flex items-start gap-3 border-t border-hair py-4">
                <AlertTriangle className="h-4 w-4 text-gold mt-1 shrink-0" strokeWidth={2} />
                <span className="text-navy text-sm lg:text-base">{sym}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="lg:col-span-5">
        <Reveal delay={0.15}>
          <figure className="relative">
            <div className="aspect-[4/5] overflow-hidden rounded-sm border border-hair">
              <img
                src={media.problem}
                alt="Aerial view of a large open-cut mine operation"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
            <figcaption className="absolute bottom-0 left-0 right-0 bg-navy/85 backdrop-blur px-5 py-4">
              <p className="text-white/90 text-sm font-medium">
                Initiatives are not the problem. The absence of a system is.
              </p>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
